import { useQuery } from "react-query";

import { QUERY_KEYS } from "../../constants/queryKeys";
import { LoyaltyApi } from "../../services";

export const useLoyaltyStatus = () => {
  const loyaltyApi = LoyaltyApi.init();
  const { data } = useQuery(QUERY_KEYS.loyaltyStatus, async () => {
    const loyaltyStatus = await loyaltyApi.getStatus();
    return { loyaltyStatus };
  });
  return data?.loyaltyStatus || false;
};
